import { language } from "@/language";

export const state = {
  isLogin: false,
  username: "",
  uid: "", // uid, 提交问卷后会更新
  serverList: [
    {
      sid: "",
      id: "",
      get sname() {
        return language.getTextByKey("server");
      },
    },
  ],
  serverIndex: 0,
  roleList: [
    {
      roleID: "",
      get roleName() {
        return language.getTextByKey("role");
      },
    },
  ],
  roleIndex: 0,
};
